import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
type ViewerLayoutProps = {
  leftSidebar: ReactNode;
  centerPanel: ReactNode;
  documentPreview: ReactNode;
  isCenterPanelOpen: boolean;
};
const ViewerLayout = t0 => {
  const $ = _c(16);
  const {
    leftSidebar,
    centerPanel,
    documentPreview,
    isCenterPanelOpen
  } = t0;
  let t1;
  if ($[0] !== leftSidebar) {
    t1 = <div className="w-full md:w-[260px] shrink-0 bg-secondary border-y border-tertiary md:overflow-y-auto md:border-y-0 md:border-r">{leftSidebar}</div>;
    $[0] = leftSidebar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !isCenterPanelOpen;
  let t3;
  if ($[2] !== isCenterPanelOpen || $[3] !== t2) {
    t3 = cx("shrink-0 overflow-hidden transition-[width] duration-500 ease-in-out", {
      "w-full md:w-[400px]": isCenterPanelOpen,
      "hidden md:block md:w-0": t2
    });
    $[2] = isCenterPanelOpen;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== centerPanel) {
    t4 = <div className="w-full md:w-[400px] h-full bg-primary md:overflow-y-auto md:border-r md:border-tertiary">{centerPanel}</div>;
    $[5] = centerPanel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== documentPreview) {
    t6 = <div className="flex flex-1 min-w-0 min-h-[60dvh] order-first md:order-none md:min-h-0">{documentPreview}</div>;
    $[10] = documentPreview;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className="flex flex-col md:flex-row h-full w-full overflow-y-auto md:overflow-hidden">{t1}{t5}{t6}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default ViewerLayout;